import { ConfigBase } from '@hpfe/common-base';

export class Config extends ConfigBase {
  constructor() {
    super({
      countryCode: process.env.country as any,
      environmentName: process.env.environment as any,
    });
  }

  command = process.env.command as string;
}
